/** Defensive validation for retained assistant proposals. New proposals are
 * validated server-side too, but old chat history may predate those checks. */

const ISO_DATE_RE =
  /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?)?$/;

export function assertValidProposalDates(
  start: string | null | undefined,
  end: string | null | undefined,
): void {
  const parsed: Array<[string, string, number]> = [];
  for (const [field, value] of [
    ['start_date', start],
    ['end_date', end],
  ] as const) {
    if (!value) continue;
    const timestamp = Date.parse(value);
    if (!ISO_DATE_RE.test(value) || !Number.isFinite(timestamp)) {
      throw new Error(
        `Invalid proposed ${field} '${value}'. Ask SONAR to use a concrete ISO date.`,
      );
    }
    parsed.push([field, value, timestamp]);
  }
  if (parsed.length === 2 && parsed[1]![2] <= parsed[0]![2]) {
    throw new Error('Invalid proposed date range: end_date must be after start_date.');
  }
}
